<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR CONFIGURAÇÃO DE GRUPOS' : 'NOVA CONFIGURAÇÃO DE GRUPOS'" titleIcon="fas fa-users">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="$requiredBlur">
                            <el-input v-model="dados.nome" placeholder="Ex.: Rodízio 50% — Fundamental II 2026"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" prop="periodo_letivo_id" :rules="$requiredChange">
                            <el-select v-model="dados.periodo_letivo_id" style="width: 100%;">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Escopo" prop="escopo" :rules="$requiredChange">
                            <el-select v-model="dados.escopo" style="width: 100%;" @change="escopoMudou">
                                <el-option value="rede" label="Rede"></el-option>
                                <el-option value="instituicao" label="Escola"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item v-if="dados.escopo === 'instituicao'" label="Escola"
                    prop="escopo_id" :rules="$requiredChange">
                    <el-select v-model="dados.escopo_id" filterable style="width: 100%;">
                        <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                    </el-select>
                </el-form-item>

                <h4 class="u-mt-10 u-mb-10">Recorte (opcional)</h4>
                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="Restringe quais turmas podem usar esta configuração. Em branco = não restringe."></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Modalidade">
                            <el-select v-model="dados.modalidade_id" clearable filterable style="width: 100%;">
                                <el-option v-for="m in modalidades" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Etapa da matriz">
                            <el-select v-model="dados.matriz_etapa_id" clearable filterable style="width: 100%;">
                                <el-option v-for="e in etapas" :key="e.id" :value="e.id" :label="e.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Nível escolar">
                            <el-input-number v-model="dados.nivel_escolar" :min="0" :max="9" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

                <h4 class="u-mt-10 u-mb-10">Divisão e rodízio</h4>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Quantidade de grupos" prop="qtd_grupos" :rules="$requiredChange">
                            <el-input-number v-model="dados.qtd_grupos" :min="2" :max="10" controls-position="right" style="width: 100%;"></el-input-number>
                            <small v-if="jaGerou" class="u-text-muted">
                                Já existem grupos gerados — a quantidade não pode mudar sem regerar.
                            </small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Critério de divisão" prop="criterio_divisao" :rules="$requiredChange">
                            <el-select v-model="dados.criterio_divisao" style="width: 100%;">
                                <el-option v-for="c in criterios" :key="c" :value="c" :label="rotulo(c)"></el-option>
                            </el-select>
                            <small v-if="dados.criterio_divisao === 'aleatorio'">O sorteio é reproduzível: gerar de novo dá o mesmo resultado.</small>
                            <small v-if="dados.criterio_divisao === 'manual'">A distribuição será feita à mão na tela de grupos.</small>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Regime de rodízio" prop="regime_rodizio" :rules="$requiredChange">
                            <el-select v-model="dados.regime_rodizio" style="width: 100%;">
                                <el-option v-for="r in regimes" :key="r" :value="r" :label="rotulo(r)"></el-option>
                            </el-select>
                            <small v-if="dados.regime_rodizio === 'sem_rodizio'">Cada grupo opera sempre no seu modo padrão, sem escala.</small>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item label="Situação">
                    <el-switch v-model="dados.situacao" active-text="Ativa" inactive-text="Inativa"></el-switch>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/grupo-aluno/configuracao"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO H — item 122. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        instituicoes: [], modalidades: [], etapas: [],
        criterios: [], regimes: [], jaGerou: false,
        dados: { nome: '', escopo: 'rede', escopo_id: null, periodo_letivo_id: null,
                 modalidade_id: null, nivel_escolar: null, matriz_etapa_id: null,
                 qtd_grupos: 2, criterio_divisao: 'alfabetico', regime_rodizio: 'semanal', situacao: true }
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        if (!this.modoEdicao && this.$store.state.config.periodo) this.dados.periodo_letivo_id = this.$store.state.config.periodo.id

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            this.criterios = (r.data && r.data.criterios) ? r.data.criterios : []
            this.regimes = (r.data && r.data.regimes) ? r.data.regimes : []
            this.modalidades = (r.data && r.data.modalidades) ? r.data.modalidades : []
            this.etapas = (r.data && r.data.etapas) ? r.data.etapas : []
        }).catch(e => this.$store.commit('throwException', e))

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/grupo-aluno/configuracao')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
                this.jaGerou = (reg.qtd_turmas || 0) > 0
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        rotulo (v) {
            return { alfabetico: 'Alfabética', numero_chamada: 'Nº de chamada', manual: 'Manual',
                aleatorio: 'Sorteio reproduzível', diario: 'Diário', semanal: 'Semanal',
                quinzenal: 'Quinzenal', sem_rodizio: 'Sem rodízio' }[v] || v
        },
        escopoMudou () { if (this.dados.escopo !== 'instituicao') this.dados.escopo_id = null },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Configuração salva.', type: 'success' })
                    this.$router.push('/admin/grupo-aluno/configuracao')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
